/**
 * Lightweight i18n for landing/onboarding/AI copy.
 * No external lib — keeps bundle small.
 * Adds new languages by extending TRANSLATIONS. AI prompts read the same code.
 */

export const LANGUAGES = [
  { code: "ml", label: "മലയാളം",  english: "Malayalam" },
  { code: "en", label: "English",   english: "English" },
  { code: "hi", label: "हिंदी",       english: "Hindi" },
  { code: "ta", label: "தமிழ்",     english: "Tamil" },
  { code: "te", label: "తెలుగు",    english: "Telugu" },
  { code: "kn", label: "ಕನ್ನಡ",     english: "Kannada" },
  { code: "bn", label: "বাংলা",      english: "Bengali" },
  { code: "gu", label: "ગુજરાતી",   english: "Gujarati" },
  { code: "mr", label: "मराठी",       english: "Marathi" },
  { code: "pa", label: "ਪੰਜਾਬੀ",     english: "Punjabi" },
  { code: "or", label: "ଓଡ଼ିଆ",       english: "Odia" },
  { code: "as", label: "অসমীয়া",   english: "Assamese" },
];

const T = {
  ml: {
    overline: "ശബ്ദ-അധിഷ്ഠിത, സമ്മത-ആദ്യ സഹായി",
    namaste: "നമസ്കാരം",
    welcome: "Gutvibe Health-ലേക്ക് സ്വാഗതം",
    tagline: "ഭക്ഷണം മരുന്ന് · Food as Medicine",
    hero1: "നിങ്ങളുടെ ആരോഗ്യം,",
    hero2: "സൗമ്യമായി വഴികാട്ടപ്പെടുന്നു.",
    desc: "Priya — ഒരു 30-വയസ്സുള്ള മലയാളി AI ആരോഗ്യ സഖി — നിങ്ങളുടെ ഭാഷയിൽ കേൾക്കുന്നു, പിന്നീട് വിശ്വാസ്യമായ ഡോക്ടർമാരിലേക്കും ലാബുകളിലേക്കും അടിയന്തിര സഹായത്തിലേക്കും നിങ്ങളെ ബന്ധിപ്പിക്കുന്നു. രോഗനിർണയമില്ല. കേരളത്തിന്റെ പോഷക പാരമ്പര്യത്തിൽ വേരൂന്നിയ ശാന്ത, ശാസ്ത്ര-അധിഷ്ഠിത മാർഗനിർദേശം.",
    ctaPrimary: "യാത്ര ആരംഭിക്കൂ",
    ctaSecondary: "എനിക്ക് ഒരു അക്കൗണ്ട് ഉണ്ട്",
    listening: "കേൾക്കുന്നു…",
    principles: "സമ്മത-ആദ്യം · ശബ്ദ-അധിഷ്ഠിതം · മനുഷ്യ-മേൽനോട്ടം",
    signIn: "സൈൻ ഇൻ",
    getStarted: "ആരംഭിക്കൂ",
  },
  en: {
    overline: "A voice-first, consent-first companion",
    namaste: "Namaste",
    welcome: "Welcome to Gutvibe Health",
    tagline: "Food as Medicine · ഭക്ഷണം മരുന്ന്",
    hero1: "Your health,",
    hero2: "gently guided.",
    desc: "Priya — a 30-year-old Malayali AI health companion — listens in your language, then connects you to trusted clinicians, verified labs, regional nutrition and emergency help. No diagnoses. Just calm, science-oriented guidance rooted in Kerala's wellness heritage.",
    ctaPrimary: "Begin your journey",
    ctaSecondary: "I have an account",
    listening: "listening…",
    principles: "Consent-first · Voice-enabled · Human-supervised",
    signIn: "Sign in",
    getStarted: "Get started",
  },
  hi: {
    overline: "आवाज़-प्रथम, सहमति-प्रथम साथी",
    namaste: "नमस्ते",
    welcome: "Gutvibe Health में आपका स्वागत है",
    tagline: "भोजन ही औषधि · Food as Medicine",
    hero1: "आपका स्वास्थ्य,",
    hero2: "कोमलता से मार्गदर्शित।",
    desc: "Priya — एक 30 वर्षीय मलयाली AI स्वास्थ्य साथी — आपकी भाषा में सुनती है, फिर आपको भरोसेमंद डॉक्टरों, प्रमाणित प्रयोगशालाओं, क्षेत्रीय पोषण और आपातकालीन सहायता से जोड़ती है। कोई निदान नहीं। बस शांत, विज्ञान-आधारित मार्गदर्शन।",
    ctaPrimary: "यात्रा शुरू करें",
    ctaSecondary: "मेरा खाता है",
    listening: "सुन रही हूँ…",
    principles: "सहमति-प्रथम · आवाज़-सक्षम · मानव-पर्यवेक्षित",
    signIn: "साइन इन",
    getStarted: "शुरू करें",
  },
  ta: {
    overline: "குரல்-முதன்மை, சம்மத-முதன்மை துணை",
    namaste: "வணக்கம்",
    welcome: "Gutvibe Health-க்கு வரவேற்கிறோம்",
    tagline: "உணவே மருந்து · Food as Medicine",
    hero1: "உங்கள் ஆரோக்கியம்,",
    hero2: "மென்மையாக வழிநடத்தப்படுகிறது.",
    desc: "Priya — 30 வயதுடைய மலையாளி AI உடல்நல தோழி — உங்கள் மொழியில் கேட்கிறாள், பின்னர் நம்பகமான மருத்துவர்கள், சான்றளிக்கப்பட்ட ஆய்வகங்கள், பிராந்திய ஊட்டச்சத்து மற்றும் அவசர உதவியுடன் உங்களை இணைக்கிறாள்.",
    ctaPrimary: "பயணத்தைத் தொடங்குங்கள்",
    ctaSecondary: "கணக்கு உள்ளது",
    listening: "கேட்கிறேன்…",
    principles: "சம்மத-முதன்மை · குரல்-இயக்கப்பட்ட · மனித-மேற்பார்வை",
    signIn: "உள்நுழை",
    getStarted: "தொடங்கு",
  },
  te: {
    overline: "వాయిస్-ఫస్ట్, సమ్మతి-ఫస్ట్ సహచరి",
    namaste: "నమస్తే",
    welcome: "Gutvibe Health కి స్వాగతం",
    tagline: "ఆహారమే ఔషధం · Food as Medicine",
    hero1: "మీ ఆరోగ్యం,",
    hero2: "సున్నితంగా మార్గనిర్దేశనం.",
    desc: "Priya — 30 ఏళ్ల మలయాళీ AI ఆరోగ్య తోడు — మీ భాషలో వింటుంది, ఆపై విశ్వసనీయ వైద్యులు, ధృవీకరించబడిన ప్రయోగశాలలు, ప్రాంతీయ పోషకాహారం మరియు అత్యవసర సహాయంతో మిమ్మల్ని కలుపుతుంది.",
    ctaPrimary: "ప్రయాణం ప్రారంభించండి",
    ctaSecondary: "నా వద్ద ఖాతా ఉంది",
    listening: "వింటున్నాను…",
    principles: "సమ్మతి-ఫస్ట్ · వాయిస్-ఎనేబుల్ · మానవ-పర్యవేక్షణ",
    signIn: "సైన్ ఇన్",
    getStarted: "ప్రారంభించు",
  },
  kn: {
    overline: "ಧ್ವನಿ-ಮೊದಲ, ಒಪ್ಪಿಗೆ-ಮೊದಲ ಸಂಗಾತಿ",
    namaste: "ನಮಸ್ಕಾರ",
    welcome: "Gutvibe Health ಗೆ ಸ್ವಾಗತ",
    tagline: "ಆಹಾರವೇ ಔಷಧ · Food as Medicine",
    hero1: "ನಿಮ್ಮ ಆರೋಗ್ಯ,",
    hero2: "ಮೃದುವಾಗಿ ಮಾರ್ಗದರ್ಶನ.",
    desc: "Priya — 30 ವರ್ಷದ ಮಲಯಾಳಿ AI ಆರೋಗ್ಯ ಸಂಗಾತಿ — ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಆಲಿಸುತ್ತಾಳೆ, ನಂತರ ವಿಶ್ವಾಸಾರ್ಹ ವೈದ್ಯರು ಮತ್ತು ಪ್ರಯೋಗಾಲಯಗಳಿಗೆ ಸಂಪರ್ಕಿಸುತ್ತಾಳೆ.",
    ctaPrimary: "ಪ್ರಯಾಣ ಪ್ರಾರಂಭಿಸಿ",
    ctaSecondary: "ನನಗೆ ಖಾತೆ ಇದೆ",
    listening: "ಆಲಿಸುತ್ತಿದ್ದೇನೆ…",
    principles: "ಒಪ್ಪಿಗೆ-ಮೊದಲ · ಧ್ವನಿ-ಸಕ್ರಿಯ · ಮಾನವ-ಪರಿಶೀಲಿತ",
    signIn: "ಸೈನ್ ಇನ್",
    getStarted: "ಪ್ರಾರಂಭಿಸಿ",
  },
  bn: {
    overline: "কণ্ঠ-প্রথম, সম্মতি-প্রথম সঙ্গী",
    namaste: "নমস্কার",
    welcome: "Gutvibe Health-এ স্বাগতম",
    tagline: "খাদ্যই ঔষধ · Food as Medicine",
    hero1: "আপনার স্বাস্থ্য,",
    hero2: "কোমলভাবে পরিচালিত।",
    desc: "Priya — একজন 30 বছর বয়সী মালয়ালী AI স্বাস্থ্য সঙ্গী — আপনার ভাষায় শোনেন, তারপর আপনাকে বিশ্বস্ত ডাক্তার, যাচাইকৃত ল্যাব এবং জরুরি সাহায্যের সাথে সংযুক্ত করেন।",
    ctaPrimary: "যাত্রা শুরু করুন",
    ctaSecondary: "আমার একটি অ্যাকাউন্ট আছে",
    listening: "শুনছি…",
    principles: "সম্মতি-প্রথম · কণ্ঠ-সক্ষম · মানব-তত্ত্বাবধানে",
    signIn: "সাইন ইন",
    getStarted: "শুরু করুন",
  },
  gu: {
    overline: "અવાજ-પ્રથમ, સંમતિ-પ્રથમ સાથી",
    namaste: "નમસ્તે",
    welcome: "Gutvibe Health માં આપનું સ્વાગત છે",
    tagline: "ખોરાક એ દવા · Food as Medicine",
    hero1: "તમારું આરોગ્ય,",
    hero2: "કોમળતાથી માર્ગદર્શન.",
    desc: "Priya — 30 વર્ષની મલયાળી AI આરોગ્ય સાથી — તમારી ભાષામાં સાંભળે છે, પછી તમને વિશ્વસનીય ડોકટરો અને પ્રયોગશાળાઓ સાથે જોડે છે.",
    ctaPrimary: "યાત્રા શરૂ કરો",
    ctaSecondary: "મારી પાસે એકાઉન્ટ છે",
    listening: "સાંભળી રહી છું…",
    principles: "સંમતિ-પ્રથમ · અવાજ-સક્ષમ · માનવ-દેખરેખ",
    signIn: "સાઇન ઇન",
    getStarted: "શરૂ કરો",
  },
  mr: {
    overline: "आवाज-प्रथम, संमती-प्रथम साथी",
    namaste: "नमस्कार",
    welcome: "Gutvibe Health मध्ये आपले स्वागत आहे",
    tagline: "अन्न हेच औषध · Food as Medicine",
    hero1: "तुमचे आरोग्य,",
    hero2: "सौम्यपणे मार्गदर्शित.",
    desc: "Priya — 30 वर्षांची मलयाळी AI आरोग्य सोबती — तुमच्या भाषेत ऐकते, नंतर विश्वासार्ह डॉक्टर आणि प्रयोगशाळांशी जोडते.",
    ctaPrimary: "प्रवास सुरू करा",
    ctaSecondary: "माझे खाते आहे",
    listening: "ऐकत आहे…",
    principles: "संमती-प्रथम · आवाज-सक्षम · मानव-देखरेख",
    signIn: "साइन इन",
    getStarted: "सुरू करा",
  },
  pa: {
    overline: "ਆਵਾਜ਼-ਪਹਿਲਾਂ, ਸਹਿਮਤੀ-ਪਹਿਲਾਂ ਸਾਥੀ",
    namaste: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ",
    welcome: "Gutvibe Health ਵਿੱਚ ਸੁਆਗਤ ਹੈ",
    tagline: "ਭੋਜਨ ਹੀ ਦਵਾਈ · Food as Medicine",
    hero1: "ਤੁਹਾਡੀ ਸਿਹਤ,",
    hero2: "ਨਰਮੀ ਨਾਲ ਸੇਧਿਤ।",
    desc: "Priya — 30 ਸਾਲ ਦੀ ਮਲਿਆਲੀ AI ਸਿਹਤ ਸਾਥੀ — ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਸੁਣਦੀ ਹੈ, ਫਿਰ ਭਰੋਸੇਯੋਗ ਡਾਕਟਰਾਂ ਨਾਲ ਜੋੜਦੀ ਹੈ।",
    ctaPrimary: "ਯਾਤਰਾ ਸ਼ੁਰੂ ਕਰੋ",
    ctaSecondary: "ਮੇਰਾ ਖਾਤਾ ਹੈ",
    listening: "ਸੁਣ ਰਹੀ ਹਾਂ…",
    principles: "ਸਹਿਮਤੀ-ਪਹਿਲਾਂ · ਆਵਾਜ਼-ਸਮਰੱਥ · ਮਨੁੱਖੀ-ਨਿਗਰਾਨੀ",
    signIn: "ਸਾਈਨ ਇਨ",
    getStarted: "ਸ਼ੁਰੂ ਕਰੋ",
  },
  or: {
    overline: "ସ୍ୱର-ପ୍ରଥମ, ସହମତି-ପ୍ରଥମ ସାଥୀ",
    namaste: "ନମସ୍କାର",
    welcome: "Gutvibe Health କୁ ସ୍ୱାଗତ",
    tagline: "ଖାଦ୍ୟ ହିଁ ଔଷଧ · Food as Medicine",
    hero1: "ଆପଣଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ,",
    hero2: "କୋମଳଭାବେ ପଥପ୍ରଦର୍ଶିତ।",
    desc: "Priya — 30 ବର୍ଷୀୟା ମଳୟାଳୀ AI ସ୍ୱାସ୍ଥ୍ୟ ସାଥୀ — ଆପଣଙ୍କ ଭାଷାରେ ଶୁଣନ୍ତି ଏବଂ ବିଶ୍ୱସ୍ତ ଡାକ୍ତରମାନଙ୍କ ସହ ଯୋଡ଼ନ୍ତି।",
    ctaPrimary: "ଯାତ୍ରା ଆରମ୍ଭ କରନ୍ତୁ",
    ctaSecondary: "ମୋର ଏକାଉଣ୍ଟ ଅଛି",
    listening: "ଶୁଣୁଛି…",
    principles: "ସହମତି-ପ୍ରଥମ · ସ୍ୱର-ସକ୍ଷମ · ମାନବ-ତତ୍ତ୍ୱାବଧାନ",
    signIn: "ସାଇନ୍ ଇନ୍",
    getStarted: "ଆରମ୍ଭ କରନ୍ତୁ",
  },
  as: {
    overline: "মাত-প্ৰথম, সন্মতি-প্ৰথম সংগী",
    namaste: "নমস্কাৰ",
    welcome: "Gutvibe Health লৈ স্বাগতম",
    tagline: "খাদ্যই ঔষধ · Food as Medicine",
    hero1: "আপোনাৰ স্বাস্থ্য,",
    hero2: "কোমলভাৱে পথ প্ৰদৰ্শিত।",
    desc: "Priya — ৩০ বছৰীয়া মালয়ালী AI স্বাস্থ্য সংগী — আপোনাৰ ভাষাত শুনে আৰু বিশ্বাসযোগ্য চিকিৎসকৰ সৈতে সংযোগ কৰে।",
    ctaPrimary: "যাত্ৰা আৰম্ভ কৰক",
    ctaSecondary: "মোৰ একাউণ্ট আছে",
    listening: "শুনি আছোঁ…",
    principles: "সন্মতি-প্ৰথম · মাত-সক্ষম · মানৱ-তত্ত্বাৱধান",
    signIn: "চাইন ইন",
    getStarted: "আৰম্ভ কৰক",
  },
};

export const DEFAULT_LANG = "ml";

export function getLang() {
  return localStorage.getItem("gv_lang") || DEFAULT_LANG;
}

export function setLang(code) {
  localStorage.setItem("gv_lang", code);
  window.dispatchEvent(new CustomEvent("gv-lang-change", { detail: code }));
}

export function t(code, key) {
  return (T[code] && T[code][key]) || T.en[key] || key;
}

export function tAll(code) {
  return T[code] || T.en;
}
